import styled from "@emotion/styled";

export const MainPage = styled.div`
    position: relative;
    padding: 0 1rem 5.5rem;

    @media screen and (min-width: ${(props) => props.theme.breakpoints.screen_md}) {
        padding: 0 1.5rem 5.5rem;
    }
`;
